import { render, staticRenderFns } from "./ProfessionalBadges.vue?vue&type=template&id=02fe36fe&scoped=true"
var script = {}
import style0 from "./ProfessionalBadges.vue?vue&type=style&index=0&id=02fe36fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe36fe",
  null
  
)

export default component.exports